import { createApp } from 'vue'
// i18n （PS：导入放到 APP.vue 导入之前，因为后面我们会在 app.vue 中使用国际化内容）
import App from './App.vue'
import router from './router'
import store from './store'
// 导入 svgIcon
import installIcons from '@/icons'
// filter
import installFilter from '@/filters'
import installDirective from '@/directives'
// 导入全局样式
import 'element-plus/dist/index.css'

import '@wangeditor/editor/dist/css/style.css' // 引入 css
import './styles/index.scss'
// 导入权限控制模块
import './permission'
// import 'default-passive-events'

if (process.env?.NODE_ENV !== 'development') {
  console.log = function () {}
  // 还可以添加 .info .warn .error
}

const app = createApp(App)

installIcons(app)
installFilter(app)
installDirective(app)
app.use(store).use(router).mount('#app')
